<template>
  <base-toggle v-model="model">
    <svg
      class="vf-9xwpv3"
      :height="sizes[size]"
      viewBox="0 0 10 10"
      :width="sizes[size]"
    >
      <path v-for="(animation, i) in paths" :key="i" :d="animation[0]">
        <animate
          ref="refs"
          v-bind="{
            attributeName: 'd',
            begin: 'indefinite',
            dur: '150ms',
            fill: 'freeze',
            values: getSvgAnimateValues(animation, !model),
          }"
        />
      </path>
    </svg>
    <slot />
  </base-toggle>
</template>

<script lang="ts" setup>
import type { IconSizes } from '#types/sizes'

const { size = 'lg' } = defineProps<{ size?: IconSizes }>()

const { size: sizes } = useAppConfig().components.vf.icon
const { paths } = useAppConfig().components.icon.menu

const model = defineModel<boolean>()
const refs = ref<SVGAnimateElement[]>([])

watch(model, () => refs.value.forEach((el) => el.beginElement()))
</script>
